import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { SECURITY_PAGE_TABS } from 'src/assets/data/security-tabs';
import TabTemplate from './tab-template';

export default function SecurityTabTable() {
  const theme = useTheme();
  const tabNames = ['Overview', 'Encryption', 'Access', 'Privacy', 'Monitoring', 'Vulnerability', 'Third Party', 'Continuity', 'Report', 'Training'];
  const [activeTab, setActiveTab] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newTab: number) => {
    setActiveTab(newTab);
  };

  const tabsContainerStyles = {
    borderRight: theme.palette.mode === 'dark' ? 0 : 1,
    borderColor: theme.palette.divider,
    ml: 3,
    maxWidth: 1000,
    '& .MuiTab-root': {
      fontSize: '1.2em',
      lineHeight: '3.0em',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  };

  const renderTabPanel = (panelIndex: number, content: React.ReactNode) => (
    <div
      role="tabpanel"
      hidden={activeTab !== panelIndex}
      id={`vertical-tabpanel-${panelIndex}`}
      aria-labelledby={`vertical-tab-${panelIndex}`}
      style={{ flexGrow: 1 }}
    >
      {activeTab === panelIndex && (
        <Box sx={{ p: 3, height: '100%' }}>
          <Typography component="span" sx={{ display: 'block' }}>
            {content}
          </Typography>
        </Box>
      )}
    </div>
  );

  const getTabProps = (panelIndex: number) => ({
    id: `vertical-tab-${panelIndex}`,
    'aria-controls': `vertical-tabpanel-${panelIndex}`,
  });

  return (
    <>
      <Typography variant="h3" sx={{ width: '100%', pb: { xs: 6, md: 10 }, mt: { xs: 4, md: 10 } }}>
        Security and Trust
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          bgcolor: theme.palette.mode === 'dark' ? 'transparent' : 'background.paper',
          height: 'auto',
          maxWidth: 1100,
          minHeight: 700,
          mx: 'auto',
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={activeTab}
          onChange={handleTabChange}
          aria-label="Vertical security tabs"
          sx={tabsContainerStyles}
        >
          {tabNames.map((label, index) => (
            <Tab key={index} iconPosition="start" label={label} {...getTabProps(index)} />
          ))}
        </Tabs>
        <Box sx={{ flexGrow: 1 }}>
          {SECURITY_PAGE_TABS.map((tab, index) =>
            renderTabPanel(
              index,
              <TabTemplate
                icon={tab.icon}
                title={tab.title}
                text={tab.text}
              />
            )
          )}
        </Box>
      </Box>
    </>
  );
}
